import { GridTabs } from '@ihsm/ui-shared';
import React, { useMemo } from 'react';
import { FACTORS_TAB, VALUES_TAB } from 'scenes/marketdata/constants';
import { useMarketDataViewState } from 'scenes/marketdata/hooks';
import { MarketDataGridMemoized } from 'shared/components/ReactDataGrid/MarketDataGrid/components/MarketDataGrid';
import { getColumns } from 'shared/components/ReactDataGrid/MarketDataGrid/utils';
import { TimeseriesChartItem } from 'shared/components/TimeseriesChart/types';
import './MarketDataTable.scss';
import { getMarketDataTableData } from './utils';

type MarketDataProps = {
  chartData: TimeseriesChartItem[];
};

export const MarketDataTable: React.FC<MarketDataProps> = ({
  chartData,
}): JSX.Element => {
  const columns = useMemo(() => {
    return getColumns(chartData);
  }, [chartData]);
  const { selectedGridTabValue, onGridChange } = useMarketDataViewState();

  const gridData = useMemo(() => {
    return getMarketDataTableData(chartData);
  }, [chartData]);

  return (
    <div className="bottom_table">
      <GridTabs
        activeTab={selectedGridTabValue}
        tabs={[VALUES_TAB, FACTORS_TAB]}
        disabledTabs={[]}
        onChange={onGridChange}
      />
      <div className="table-wrapper">
        <div className="data-grid">
          <MarketDataGridMemoized data={gridData} columns={columns} />
        </div>
      </div>
    </div>
  );
};
